import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../../../global-components/global-components.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {PageNotFoundHomeControllerComponent} from './page-not-found-home-controller.component';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [
        PageNotFoundHomeControllerComponent
    ],
    exports: [
        PageNotFoundHomeControllerComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        GlobalComponentsModule,
        SharedComponentsModule,
    ]
})
export class PageNotFoundHomeModule {}
